module.exports = __webpack_public_path__ + "assets/ic_badge_04.d052f399.svg";